import api from './api.js'

class AdminUser {
    constructor(){
        this.url_admin_users = 'Account/SmartSales'
    }

    all(){
        return api.get(this.url_admin_users);
    }
    create(data){
        return api.post(this.url_admin_users, data);
    }
}

export default new AdminUser;
